import React, { useState } from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Paper, TextField, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const ClientList = () => {
    const [search, setSearch] = useState('');
    const [clients, setClients] = useState([
        { id: 1, name: 'John Doe', email: 'john@example.com', phone: '123-456-7890', company: 'TechCorp', registered: '2022-10-01' },
        { id: 2, name: 'Jane Smith', email: 'jane@example.com', phone: '987-654-3210', company: 'HealthPlus', registered: '2022-09-10' },
        // ... (otros clientes)
    ]);

    const filteredClients = clients.filter(client => 
        client.name.toLowerCase().includes(search.toLowerCase()) ||
        client.email.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 2 }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Buscar cliente"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Nombre o correo electrónico"
                />
            </Box>

            <Paper elevation={3}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nombre</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Teléfono</TableCell>
                            <TableCell>Empresa</TableCell>
                            <TableCell>Registrado</TableCell>
                            <TableCell>Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredClients.map(client => (
                            <TableRow key={client.id}>
                                <TableCell>{client.name}</TableCell>
                                <TableCell>{client.email}</TableCell>
                                <TableCell>{client.phone}</TableCell>
                                <TableCell>{client.company}</TableCell>
                                <TableCell>{client.registered}</TableCell>
                                <TableCell>
                                    <Tooltip title="Editar">
                                        <IconButton color="primary" size="small">
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Eliminar">
                                        <IconButton color="error" size="small">
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Box>
    );
};

export default ClientList;
